import { lazy } from 'react';

export const PartnerPortalTopFrameComponents = {
    PartnerPortalTopFrame: lazy(() => import('./partner-portal-top-frame')),
};
